<template>
  <div></div>
</template>

<script>
import { studentStatus } from "@/api/user.js";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      applyStatus: 0 //: 0-待提交; 1-待通过; 2-认证未通过; 3-已通过
    };
  },
  created() {
    const { code, state } = this.$route.query;
    if (code && state) {
      this.handleLogin({
        code,
        source: state
      })
        .then(res => {
          console.log(res);
          if (res.phone) {
            // 去首页
            if (res.status === 1) {
              this.$router.replace("/");
            } else {
              this._studentStatus(0);
            }
          } else {
            // 去绑定手机
            this.$router.replace("/user/bindphone");
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
  },
  methods: {
    ...mapActions({
      handleLogin: "wechatLogin"
    }),
    async _studentStatus() {
      await studentStatus().then(res => {
        this.applyStatus = res.results.applyStatus;
        if (this.applyStatus === 0) {
          this.$router.replace("/applySubject");
        } else {
          this.$router.push({ name: "StudentCourseList" });
        }
      });
    }
  }
};
</script>
